'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-error-notice {\n  padding: 40px;\n  text-align: center;\n  border: 1px solid #d2d8dd; }\n  @media (min-width: 768px) {\n    .varta-error-notice {\n      padding: 50px; } }\n  .varta-error-notice__icon {\n    fill: #fada35;\n    color: #fada35;\n    border: 3px solid;\n    padding: 10px;\n    border-radius: 50%;\n    display: inline-block;\n    line-height: 0; }\n";
styleInject_es(css_248z);
